import React from 'react';
import PropTypes from 'prop-types';
import eol from 'eol';

function str2Val(str, scope = window) {
    const keys = str.split(/[\.\[\]'"]/).filter(e => e);
    let ret = scope;

    try {
        keys.forEach((key) => {
            ret = ret[key];
            if (ret === true) {
                ret = 'Yes';
            } else if (ret === false) {
                ret = 'No';
            }
        });
        return ret;
    } catch (e) {
        return '';
    }
}

const ExportTable = props => (
    <table id={props.id} className="table" style={{ display: 'none' }}>
        <thead>
            <tr>
                {props.column.map(col => (
                    <th key={col.accessor || Math.random()}>
                        {typeof col.Header === 'function' ? col.Header() : col.Header}
                    </th>
                ))}
            </tr>
        </thead>
        <tbody>
            {props.data.map((row, index) => (
                <tr key={`tr-${row.Id}`}>
                    {props.column.map((col) => {
                        let value = col.accessor ? str2Val(col.accessor || '', row) : (index + 1).toString().padStart(2, '0');
                        if (typeof value === 'string') {
                            value = eol.auto(value);
                        }
                        return (
                            <td key={`td${row.Id}${col.accessor}`}>
                                {value}
                            </td>
                        );
                    })}
                </tr>
            ))}
        </tbody>
    </table>
);

ExportTable.propTypes = {
    id: PropTypes.string,
    data: PropTypes.array.isRequired,
    column: PropTypes.array.isRequired,
};

ExportTable.defaultProps = {
    id: 'tableExportGuest',
};


export default ExportTable;
